import * as React from "react";
import { ThemeProvider, styled } from "@material-ui/core/styles";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { theme as defaultTheme } from "./utils/Theme";
import { FirebasePageAnalytics } from "./utils/Analytics";
import { Authenticator, FirebaseAuthenticator } from "./utils/Auth";

import { MarketingPage } from "./pages/MarketingPage";

const Main = styled("div")({
  width: "100%",
  overflowX: "hidden",
  overflowY: "hidden",
});

class App extends React.Component<{}, {}> {
  // authenticator: Authenticator = new StubAuthenticator();
  authenticator: Authenticator = new FirebaseAuthenticator();

  componentDidMount() {
    this.authenticator.init();
  }

  public renderWithTheme(content: JSX.Element) {
    return <ThemeProvider theme={defaultTheme}>{content}</ThemeProvider>;
  }

  public render() {
    return (
      <ThemeProvider theme={defaultTheme}>{this.renderContent()}</ThemeProvider>
    );
  }

  public renderContent() {
    return (
      <Router>
        <FirebasePageAnalytics />
        <div className="App">
          <Main>
            <Switch>
              <Route exact={true} path="/">
                <MarketingPage />
              </Route>
              <Route path="*">
                <MarketingPage />
              </Route>
            </Switch>
          </Main>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx